export default __webpack_public_path__ + "static/media/dis1.775768a1.png";